export const STATIC_ANSWERS_DIAGNOSES = 'diagnoses';
export const STATIC_ANSWERS_TREATMENTS = 'treatments';
